import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

import { Grid, Paper } from "@material-ui/core";
import LaunchIcon from '@material-ui/icons/Launch';
import { withStyles } from "@material-ui/styles";
import Select from 'react-select';
import axios from "axios";
import { api } from "./api/client";

const OFIS_TASK_MANAGER = process.env.REACT_APP_OFIS_TASK_MANAGER || '';
const defaultToolbarSelectStyles = {
    container:{
        flexDirection:"row",
        width: "80%",
        fontSize:'10'
    },
    iconButton: {
        color: '#f60',
        marginTop:'10px',
        alignContent: "flex-end",
        backgroundColor:'#e5e5e5'

    },
    iconContainer: {
        marginRight: "24px",
    },
    formContainer: {
        marginRight: "0px",
        marginLeft:"-10px",
        flexDirection:"column",
        width: "50%",
        alignContent: "flex-start",
    },
    inverseIcon: {
        transform: "rotate(90deg)",
    },
};

class CustomToolbarSelect extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            departmanlar : [],
            hataKodlari:[],
            id: "",
            name: '',
            selectedHataKodu:'',
            selectedDepartman:''
        }
    }

    handleClickBlockSelected = async () => {

        //let url = "google.com";
        //window.open(url, '_blank').focus();
        let not_idleri= this.props.data.map(row => row.id);
        let is_emri_nolari= this.props.data.map(row => row.is_emri_no);
        let uyfler= this.props.data.map(row => row.uyfler);
        let notlar= this.props.data.map(row => row.aciklama);
        uyfler=JSON.parse(JSON.stringify(uyfler))
        let uyf_listesi=[]
        uyfler.map((row)=>{
            let uyf=JSON.parse(row)
            uyf_listesi.push(uyf.join(' , '))
        })
        let user_name='Ömer TAŞDEMİR'
        let departman=this.state.selectedDepartman.value;
        const postData = { "not_idleri": not_idleri, "uyfler": uyf_listesi,"notlar":notlar,user_name:user_name,departman:departman};


        // Eğer dizi uzunlukları eşit değilse, hata mesajı döndür
        if (!(not_idleri.length === uyfler.length && uyfler.length === notlar.length)) {
            console.error("Dizilerin uzunlukları eşit olmalıdır.");
            return;
        }

        // Her bir öğe için addTaskManager fonksiyonunu asenkron olarak çağır
        for (let i = 0; i < not_idleri.length; i++) {
            const postData = {
                not_id: not_idleri[i],
                uyf: uyf_listesi[i],
                not: notlar[i],
                is_emri_no: is_emri_nolari[i],
                user_name,
                departman,

            };

            await this.addTaskManager(postData).then(()=>{


            });
        }

        //await this.addTaskManager(postData)

    };


    async hataKodlari(){

        const res = await api.get('/kirmizi-defter/hata-kodlari')
        const data = res.data

        const hataKodlari = data.map(d => ({

            "value" :  d.description,
            "label" :  d.description,

        }))
        //console.log(products);
        this.setState({hataKodlari: hataKodlari})

    }
    async departmanlar(){

        const res = await api.get('/kirmizi-defter/departmanlar')
        const data = res.data

        const departmanlar = data.map(d => ({
            "value" :  d.departman_adi,
            "label" :  d.departman_kodu,

        }))
        //console.log(products);
        this.setState({departmanlar: departmanlar})

    }


    async addTaskManager(postData) {
        if (!OFIS_TASK_MANAGER) {
            window.alert('Görev ekleme yalnızca ofis task-manager ile (REACT_APP_OFIS_TASK_MANAGER).');
            this.props.getDatas('error');
            return;
        }
        await axios.post(`${OFIS_TASK_MANAGER}/gorev-ekle-web`, {
            postData
        })
            .then((response) => {
                // Success 🎉
                console.log(response);
                this.props.getDatas('success')
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
                this.props.getDatas('error')
            });

    }
    componentDidMount() {
        this.hataKodlari();
        this.departmanlar()
    }


    handleChange = (name,value) => {
        this.setState({ [name]: value });
        console.log(name,value)
    }
     render() {
        const { classes } = this.props;

        return (
        <div className={classes.container}>
            <div className={classes.formContainer}>

            </div>
            <div className={classes.formContainer}>

            </div>
            <Grid container spacing={2}>

                <Grid item xs={6} md={5}>
                    <label>
                        Departman Seçiniz:</label>
                        <Select  style={{width: `300px`}} value={this.state.selectedDepartman} options={this.state.departmanlar}   name={'selectedDepartman'}  onChange={(value, actionMeta) => this.handleChange(actionMeta.name,value)} />

                </Grid>
                <Grid item xs={2} md={2}>
                    <Tooltip title={"Seçili olanları Kırmızı Defter'e aktar"}>
                        <IconButton className={classes.iconButton} onClick={this.handleClickBlockSelected}>
                            <LaunchIcon className={classes.icon} />
                        </IconButton>
                    </Tooltip>
                </Grid>

            </Grid>
        </div>
    );
    }
}

export default withStyles(defaultToolbarSelectStyles, {name: "CustomToolbarSelect"})(CustomToolbarSelect);
